import {
  AllowStringForNumbers,
  SiteAllowStringValues,
  SiteCalculations,
  SiteElectricalSystem,
} from "@inrange/building-manager-api-client/models-site";
import { formatUnits } from "@inrange/theme-components/formatting";

export const getCurtailmentDetails = (
  site: SiteAllowStringValues,
  siteCalculations: SiteCalculations,
  esys?: AllowStringForNumbers<SiteElectricalSystem>
): [string | undefined, string, string] => {
  let curtailment: string | undefined = undefined;
  let curtailmentRisk = "unknown";
  let curtailmentColor = "orange";

  const energyFlowAnnual =
    esys !== undefined
      ? siteCalculations.esys?.[esys.idx]?.energyFlowAnnual
      : siteCalculations.energyFlowAnnual;
  if (!energyFlowAnnual) {
    return [curtailment, curtailmentRisk, curtailmentColor];
  }

  const exportLimitsDefined = esys
    ? esys.exportLimit !== undefined && esys.exportLimit !== null
    : site.totalExportLimit !== undefined && site.totalExportLimit !== null;

  const installedCapacity = esys
    ? site.generation[esys.genIdx].installedCapacity
    : site.totalInstalledCapacity;

  if (installedCapacity === 0) {
    // Procure only site, no curtailment
    curtailment = "N/A";
    curtailmentColor = "inherit";
  } else if (exportLimitsDefined) {
    // Known export limit, known curtailment
    if (energyFlowAnnual.curtailed === 0) {
      curtailment = `no`;
      curtailmentColor = "inherit";
    } else if (energyFlowAnnual.curtailed < 10_000) {
      curtailment = `${formatUnits(energyFlowAnnual.curtailed, "kWh", 2)}`;
      curtailmentColor = "inherit";
    } else {
      curtailment = `${formatUnits(energyFlowAnnual.curtailed, "kWh", 2)}`;
      curtailmentColor = "red";
    }
  } else if (site.substationData?.success) {
    // Properly handle negative headroom by maxing with zero
    const maxHalfHourlyExportHeadroom = Math.max(
      0,
      ((siteCalculations.substationData?.headroom ?? 0) * 1000) / 2
    );
    // Known generation headroom, known curtailment risk
    if (
      // site.substationData.headroom is in MV, we need to convert to kWh per half hour
      maxHalfHourlyExportHeadroom >= energyFlowAnnual.maxExport
    ) {
      curtailmentRisk = "no";
      curtailmentColor = "inherit";
    } else {
      curtailmentRisk = `Max ${formatUnits(energyFlowAnnual.maxExport - maxHalfHourlyExportHeadroom, "kWh", 2)} per half hour`;
      curtailmentColor = "red";
    }
  }
  return [curtailment, curtailmentRisk, curtailmentColor];
};
